<template>
  <div id="main_content" class="home">
    <DashHeader bg_color="#435f8e" header_title="Election 2020"></DashHeader>
    <Chart
      link_to="/electoral_college"
      svg_file="/charts/latest-electoral-college-1200x900.svg"
      id="electoral"
    />
    <Chart link_to="/approval_chart" svg_file="/charts/latest-approval-1200x900.svg" id="approval" />
    <Gauges />
    <NewsItems max_items="10" />
    <div id="countdown_wrapper">
      <CountdownClock />
    </div>
  </div>
</template>

<script>
import DashHeader from "@/components/DashHeader.vue";
import Gauges from "@/components/Gauges.vue";
import Chart from "@/components/Chart.vue";
import NewsItems from "@/components/NewsItems.vue";
import CountdownClock from "@/components/CountdownClock";
export default {
  name: "Home",
  components: {
    DashHeader,
    Chart,
    Gauges,
    NewsItems,
    CountdownClock
  },
  data() {
    return {
      is_wide_view: null
    };
  },
  created() {
    window.addEventListener("resize", this.check_window_size);
  },
  destroyed() {
    window.removeEventListener("resize", this.check_window_size);
  },
  methods: {
    check_window_size() {
      this.is_wide_view = window.innerWidth > 1000;
    }
  }
};
</script>

<style >
#main_content {
  display: grid;
  height: 100%;
  grid-template-columns: 1fr;
  grid-template-areas:
    "header     "
    "electoral  "
    "approval  "
    "gauges     "
    "news       "
    "countdown  ";
}
#layout_info {
  position: fixed;
  width: 100vw;
  top: 1rem;
  opacity: 70%;
  background-color: rebeccapurple;
  color: lime;
}

.default {
  display: block;
}
.med_800,
.med_400,
.wide {
  display: none;
}
#main_content {
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: gainsboro;
}
/* Name the things */
#dash_header {
  grid-area: header;
}
#electoral {
  grid-area: electoral;
}
#approval {
  grid-area: approval;
}
#gauges_container {
  grid-area: gauges;
}
#notable_developments {
  grid-area: news;
  height: 100%;
}
#countdown_wrapper {
  grid-area: countdown;
}
#approval,
#electoral {
  border: 6px solid gainsboro;
  min-width: 350px;
  height: 100%;
  /*  max-width: 600px;*/
}

@media screen and (min-width: 400px) {
  .default {
    display: none;
  }
  .med_400 {
    display: block;
  }
  #dash_header {
    font-size: 1.2rem;
  }
}

@media screen and (min-width: 800px) {
  .default {
    display: none;
  }
  .med_800 {
    display: none;
  }
  .wide {
    display: block;
  }
  #main_content {
    position: absolute;
    top: 0;
    left: 0;
    display: grid;
    /* max-height: 100vh;
    min-height: 100vh;
    */
    width: 100%;
    height: 100%;
    display: grid;
    grid-gap: 0;
    grid-template-rows: 95px 1fr 1fr auto 100px;
    grid-template-columns: 2fr 1fr;
    grid-template-areas:
      "header    header"
      "electoral news"
      "approval  news"
      "gauges    gauges"
      "countdown countdown";
  }
}
@media screen and (min-width: 1300px) {
  .default {
    display: none;
  }
  .med_800 {
    display: block;
  }
  #main_content {
    display: grid;
    height: 100%;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 95px 1fr auto 300px;
    grid-template-areas:
      "header       header    header"
      "electoral    approval  news"
      "gauges       gauges    news"
      "gauges    gauges countdown";
  }
}
/*
#countdown_wrapper {
  min-width: 300px;
  grid-column-start: 1;
  grid-column-end: -1;
}
*/
</style>

